/**
 * AI disclosure copy — English is the source of truth.
 * Machine translations are cached server-side in aiDisclosureTranslations/{locale}.
 */

export const AI_DISCLOSURE_COPY = {
  en: {
    headline: "You are using an AI, not talking with a person.",
    noHumanNow: "No person is reading this conversation right now.",
    facilityHelp: "If you want to talk with a person, ask a staff member here.",
    remoteHelp: "If you want to talk with a person, contact your clinic or care team.",
    emergency: "In an emergency, call your local emergency number.",
    compactBadge: "AI — not a person",
  },
};

/**
 * @param {string | undefined | null} locale BCP-47
 * @returns {{ headline: string, noHumanNow: string, facilityHelp: string, remoteHelp: string, emergency: string, compactBadge: string }}
 */
export function getAiDisclosureCopy(locale) {
  const key = typeof locale === "string" ? locale.trim() : "";
  if (key && AI_DISCLOSURE_COPY[key]) {
    return AI_DISCLOSURE_COPY[key];
  }
  const base = key.split(/[-_]/)[0]?.toLowerCase();
  if (base && AI_DISCLOSURE_COPY[base]) {
    return AI_DISCLOSURE_COPY[base];
  }
  return AI_DISCLOSURE_COPY.en;
}

export function englishAiDisclosureSourceVersion() {
  return hashEnglishCopy(AI_DISCLOSURE_COPY.en);
}

/** Stable hash of English copy for cache invalidation (browser + Node). */
export function hashEnglishCopy(copy) {
  const payload = JSON.stringify(copy);
  let h = 0;
  for (let i = 0; i < payload.length; i += 1) {
    h = (Math.imul(31, h) + payload.charCodeAt(i)) | 0;
  }
  return `en-v${(h >>> 0).toString(16)}`;
}
